import type { ReactNode } from 'react';

import type { CSSProperties } from '@actual-app/components/styles';
import { css } from '@emotion/css';

type ZonaBuscadorProps = {
  /** Estilos de la franja que rodea al buscador (relleno, fondo, borde…). */
  style?: CSSProperties;
  children: ReactNode;
  'data-testid'?: string;
};

/**
 * Franja de un buscador de móvil (B2 · H04). Es un `<label>`: tocar su
 * relleno enfoca el campo (el primer control de dentro), así que la zona
 * táctil del buscador (40 px) crece hasta el alto de la franja sin cambiar
 * su aspecto. Los botones de dentro (borrar) siguen siendo suyos: el
 * navegador no reenvía al campo los toques sobre un control interactivo.
 */
export function ZonaBuscador({
  style,
  children,
  'data-testid': testId = 'zona-buscador',
}: ZonaBuscadorProps) {
  return (
    <label
      data-testid={testId}
      className={css({
        // Lo mismo que un `View` (para sustituirlo sin cambiar el aspecto).
        boxSizing: 'border-box',
        borderWidth: 0,
        borderStyle: 'solid',
        position: 'relative',
        margin: 0,
        minHeight: 0,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'text',
        ...style,
      })}
    >
      {children}
    </label>
  );
}
